import React from 'react'
import RecipeBuilderMock from './RecipeBuilderMock'

const Hero = () => (
  <section className="vt-hero vt-hero-mesh-bg" style={{ padding: '64px 0 40px' }}>
    <div className="vt-shell" style={{ display: 'grid', gridTemplateColumns: '1.02fr .98fr', gap: 52, alignItems: 'center' }}>
      <div>
        <span className="eyebrow">Nutrition clinique vétérinaire</span>
        <h1>La nutrition, <span className="accent">prescrite</span> avec rigueur.</h1>
        <p className="lede">
          Du patient à la prescription nutritionnelle validée, en cinq minutes. Certains propriétaires nourrissent en partie à la maison — et presque aucune de ces rations n'est complète. Fetchy transforme ce risque clinique en consultation rigoureuse.
        </p>
        <div className="fx gap12 wrap ac" style={{ marginTop: 28 }}>
          <a className="vt-btn vt-btn-call vt-btn-lg" href="https://app.fetchy.vet">
            Commencer l'essai
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
          </a>
          <a className="vt-btn vt-btn-outline vt-btn-lg" href="#how-it-works">Voir comment ça marche</a>
        </div>
        <div className="hero-perks">
          <span><i data-lucide="flask-conical"></i>FEDIAF · AAFCO · littérature</span>
          <span><i data-lucide="utensils-crossed"></i>ménager · industriel · mixte</span>
        </div>
      </div>
      <div>
        <RecipeBuilderMock />
      </div>
    </div>
  </section>
)

export default Hero
